import { SET_USER_LOADING, SET_USER_PERMISSIONS } from '@state-management/constants';
import { Action } from '../actions';
import { MeUserResponse } from '../models/state.models';

export interface UserReducerState {
  loading: boolean;
  loaded: boolean;
  permissions: MeUserResponse | null;
  systemuser: MeUserResponse | null;
  offices: unknown[];
}

const initialState: UserReducerState = {
  loaded: false,
  loading: false,
  permissions: null,
  systemuser: null,
  offices: [],
};

export function SystemUserReducer(state = initialState, action: Action): UserReducerState {
  switch (action.type) {
    case SET_USER_PERMISSIONS: {
      const data = action.payload?.data as MeUserResponse | null | undefined;
      if (data == null) {
        return { ...initialState };
      }
      const officesList = data?.offices?.data ?? [];
      return {
        ...state,
        loaded: true,
        loading: false,
        permissions: data,
        systemuser: data,
        offices: officesList,
      };
    }
    case SET_USER_LOADING: {
      const loading = !!action.payload?.data;
      return { ...state, loading };
    }
    default: {
      return state;
    }
  }
}

export const getLoading = (state: UserReducerState) => state?.loading ?? false;
export const getLoaded = (state: UserReducerState) => state?.loaded ?? false;
export const getUserPermissions = (state: UserReducerState) => state?.permissions ?? null;
export const getSystemUser = (state: UserReducerState) => state?.systemuser ?? null;
export const getSystemUserOffices = (state: UserReducerState) => state?.offices ?? [];
